import { SET_STORES_LIST, SET_SUPPLIERS_LIST } from '../action-types'
import * as _ from 'lodash'

const initialState = {
    stores: [],
    suppliers: []
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_STORES_LIST:
            return {
                ...state,
                stores: payload
            };

        case SET_SUPPLIERS_LIST:
            const existingSupplierIds = _.map(state.suppliers, supplier => {
                return supplier.num_foucom;
            });

            let suppliers = [...state.suppliers];

            _.forEach(payload, supplier => {
                if (existingSupplierIds.indexOf(supplier.num_foucom) > -1) {
                    return;
                }

                suppliers.push(supplier);
            });

            suppliers = _.orderBy(suppliers, ['num_foucom'], ['asc']);

            return {
                ...state,
                suppliers: suppliers
            };

        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux-store/reducers/data-reducer.js